<form [formGroup]="registerForm">
  <!-- <form [formGroup]="registerForm"> #registerForm="ngForm" -->
  <div class="ontario-form-group">
    <input type="hidden" name="menuType" id="menuType" value="public" />
    <div class="ontario-row">
      <div class="ontario-columns">
        <h2 id="pageTitle"> {{'bss.register.title' | translate }} </h2>
        <hr>
      </div>
    </div>


    <div class="ontario-row">
      <div class="ontario-column ontario-small-12">
        <div *ngIf="submitted && appError" class="ontario-alert ontario-alert--error" aria-live="polite"
          aria-atomic="true" id="pageLevelMessageId" #pageMsg>
          <div class="ontario-alert__header">
            <div class="ontario-alert__header-icon">
              <svg class="ontario-icon" alt="Error" aria-hidden="true" focusable="false" sol:category="primary"
                viewBox="0 0 24 24" preserveAspectRatio="xMidYMid meet">
                <use href="#ontario-icon-alert-error"></use>
              </svg>
            </div>
            <h2 class="ontario-alert__header-title ontario-h4">{{'bss.register.error' | translate }}</h2>
          </div>
          <div class="ontario-alert__body">
            <p [innerHTML]="appErrorMessage | translate">
          </div>
        </div>
      </div>
    </div>

    <div class="ontario-row">
      <div class="ontario-columns">
        <dl><dt class="fractal-dt ontario-padding-bottom-24-!">
          {{'bss.register.subtitle' | translate }}
        </dt><dd></dd></dl>
      </div>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="firstName">
            {{'bss.register.firstName' | translate }}
            <span class="ontario-label__flag">
              ({{'bss.register.required' | translate }})
            </span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <input tabindex="101" class="ontario-input ontario-input--20-char-width" type="text" id="firstName"
            title=" {{'bss.register.firstName.title' | translate }}" formControlName="firstName" #firstNameInput
            (input)="updateDisplayName(firstNameInput.value, middleNameInput.value, lastNameInput.value)"
            aria-describedby="firstNameError">

          <div
            *ngIf="(submitted || registerForm.get('firstName').touched || registerForm.get('firstName').dirty) && (registerForm.get('firstName').errors?.['required'])"
            id="firstNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.firstName.required' | translate }} </li>
            </ul>
          </div>

          <div
            *ngIf="(submitted || registerForm.get('firstName').touched || registerForm.get('firstName').dirty) && (registerForm.get('firstName').errors?.['pattern'])"
            id="firstNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.firstName.invalid' | translate }}</li>
            </ul>
          </div>
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="middleName">
            {{'bss.register.middleName' | translate }}<span class="ontario-label__flag"> ({{'bss.register.optional' |
              translate }}) </span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <input tabindex="102" class="ontario-input ontario-input--20-char-width" type="text" id="middleName"
            title="{{'bss.register.middleName.title' | translate }}" formControlName="middleName" #middleNameInput
            (input)="updateDisplayName(firstNameInput.value, middleNameInput.value, lastNameInput.value)">

          <div
            *ngIf="(submitted || registerForm.get('middleName').touched || registerForm.get('middleName').dirty) && (registerForm.get('middleName').errors?.['pattern'])"
            id="middleNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.middleName.invalid' | translate }} </li>
            </ul>
          </div>
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="lastName">
            {{'bss.register.lastName' | translate }}<span class="ontario-label__flag"> ({{'bss.register.required' |
              translate }})</span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <input tabindex="103" class="ontario-input ontario-input--20-char-width" type="text" id="lastName"
            aria-describedby="lastNameError" title="{{'bss.register.lastName.title' | translate }}"
            formControlName="lastName" #lastNameInput
            (input)="updateDisplayName(firstNameInput.value, middleNameInput.value, lastNameInput.value)">

          <div
            *ngIf="(submitted || registerForm.get('lastName').touched || registerForm.get('lastName').dirty) && (registerForm.get('lastName').errors?.['required'])"
            id="lastNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.lastName.required' | translate }} </li>
            </ul>
          </div>

          <div
            *ngIf="(submitted || registerForm.get('lastName').touched || registerForm.get('lastName').dirty) && (registerForm.get('lastName').errors?.['pattern'])"
            id="lastNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.lastName.invalid' | translate }} </li>
            </ul>
          </div>
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="displayName">
            {{'bss.register.displayName' | translate }}<span class="ontario-label__flag"> ({{'bss.register.required' |
              translate }})</span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <input tabindex="104" class="ontario-input ontario-input--20-char-width" type="text" id="displayName"
            aria-describedby="displayNameError" title="{{'bss.register.displayName.title' | translate }}"
            formControlName="displayName" [value]="displayName" required>

          <!--
            <div *ngIf="submitted && (registerForm.get('displayName').errors?.['required'])"
          -->
          <div
            *ngIf="(submitted || registerForm.get('displayName').touched || registerForm.get('displayName').dirty) && (displayName === '' || displayName === null || (registerForm.get('displayName').errors?.['required'])) "
            id="displayNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.displayName.required' | translate }} </li>
            </ul>
          </div>

          <div
            *ngIf="(submitted || (registerForm.get('firstName').touched && registerForm.get('lastName').touched)) && registerForm.get('displayName').errors?.['pattern']"
            id="displayNameError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.displayName.invalid' | translate }} </li>
            </ul>
          </div>
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="prefLanguage">
            {{'bss.profile.label.preferredLanguage' | translate }}<span class="ontario-label__flag"> ({{'bss.register.required' |
              translate }})</span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <div class="ontario-radios" layout="row"> 
            <div class="ontario-radios__item">
              <input aria-describedby="preFerredLanguageError" tabindex="105" class="ontario-radios__input" type="radio" id="prefLangEn" title="{{ 'bss.profile.prefLanguage.title.English' | translate }}" name="preferredLanguage" value="en" formControlName="preferredLanguage">
              <label class="ontario-label ontario-radios__label" for="prefLangEn"> {{'bss.profile.preferredLanguage.option.English' | translate }}</label>
            </div>
                 
            <div class="ontario-radios__item"> 
                <input aria-describedby="preFerredLanguageError" tabindex="106" class="ontario-radios__input" type="radio" id="prefLangFr" title="{{ 'bss.profile.prefLanguage.title.French' | translate }}" name="preferredLanguage" value="fr" formControlName="preferredLanguage">
                <label class="ontario-label ontario-radios__label" for="prefLangFr"> {{'bss.profile.preferredLanguage.option.French' | translate }}</label>
            </div>  
          </div>            

          <div *ngIf="(submitted || registerForm.get('preferredLanguage').touched || registerForm.get('preferredLanguage').dirty) 
            && (registerForm.get('preferredLanguage').errors?.['required'])" id="preFerredLanguageError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
            <ul>
                <li>{{'bss.profile.prefLanguage.error.required' | translate }} </li>
            </ul>
          </div>
        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="email">
            {{'bss.register.emailAddress' | translate }} <span class="ontario-label__flag"> ({{'bss.register.required' |
              translate }})</span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <input tabindex="107" class="ontario-input ontario-input--20-char-width" type="text" id="email"
            aria-describedby="emailError" title="{{'bss.register.emailAddress.input.title' | translate }}"
            formControlName="email">

          <div id="emailError" role="alert" aria-live="assertive"
            *ngIf="(registerForm.get('email').touched || registerForm.get('email').dirty || submitted) && registerForm.get('email').errors?.['required']"
            class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.email.required' | translate }} </li>
            </ul>
          </div>

          <div id="emailError" role="alert" aria-live="assertive"
            *ngIf="registerForm.get('email').touched && (registerForm.get('email')?.hasError('email') ||  registerForm.get('email')?.hasError('invalidEmail')) "
            class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.email.invalid' | translate }} </li>
            </ul>
          </div>

          <div id="emailError" role="alert" aria-live="assertive" *ngIf="(submitted || registerForm.get('email').touched ||
			        registerForm.get('email').dirty) && ( registerForm.get('email').errors?.['restricted'])"
            class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.login.err.email.restricted' | translate }} </li>
            </ul>
          </div>

        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="confirmEmail">
            {{'bss.register.confirmEmail' | translate }} <span class="ontario-label__flag"> ({{'bss.register.required' |
              translate }})</span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <input tabindex="108" class="ontario-input ontario-input--20-char-width" type="text" id="confirmEmail"
            aria-describedby="confirmEmailError" title=" {{'bss.register.confirmEmail.input.title' | translate }}"
            formControlName="confirmEmail">

          <div id="confirmEmailError" role="alert" aria-live="assertive"
            *ngIf="(registerForm.get('confirmEmail').dirty || registerForm.get('confirmEmail').touched)  && ((registerForm.get('confirmEmail').errors?.['required']) || registerForm.hasError('mismatchEmail') )"
            class="ontario-alert ontario-alert--error">

            <div *ngIf="(registerForm.get('confirmEmail').errors?.['required'])">
              <ul>
                <li>{{'bss.register.error.confirmEmail.required' | translate }} </li>
              </ul>
            </div>
            <div
              *ngIf="!registerForm.get('confirmEmail').errors?.['required'] && registerForm.hasError('mismatchEmail')">
              <ul>
                <li>{{'bss.register.error.confirmEmail.mismatch' | translate }} </li>
              </ul>
            </div>
          </div>

          <!--<div id="confirmEmailError" role="alert" aria-live="assertive"
            *ngIf="(submitted || registerForm.get('confirmEmail').dirty || registerForm.get('confirmEmail').touched) && !(registerForm.get('confirmEmail').errors?.['required'] || registerForm.get('confirmEmail').errors?.['email']) && registerForm.hasError('mismatchEmail') " 
            class="ontario-alert ontario-alert--error">
              <ul>
                <li>{{'bss.register.error.confirmEmail.mismatch' | translate }} </li>
              </ul>            
          </div>-->

        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="password">
            {{'bss.register.password' | translate }}<span class="ontario-label__flag"> ({{'bss.register.required' |
              translate }})</span>
          </label>
        </div>
        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <div class="toggle-container ontario-input--20-char-width">
            <input aria-describedby="passwordError" tabindex="109" formControlName="password" id="password"
              name="password" type="{{ showPassword === false ? 'password' : 'text' }}"
              title="{{ 'bss.register.password.input.title' | translate }}"
              class="ontario-input ontario-input--20-char-width">

            <a tabindex="110" id="passwordToggler" *ngIf="registerForm.get('password').value"
              (click)="toggleShowPassword()" (keyup.enter)="toggleShowPassword()"
              title="{{ showPassword === false ? ('bss.register.showPassword.title' | translate) : ('bss.register.hidePassword.title' | translate) }}">
              {{ showPassword === false ? ('bss.register.password.show' | translate) : ('bss.register.password.hide' |
              translate) }}
            </a>
          </div>

          <div id="passwordError" role="alert" aria-live="assertive"
            *ngIf="(registerForm.get('password').touched || registerForm.get('password').dirty || submitted) && (registerForm.get('password').errors?.['required'])"
            class="ontario-alert ontario-alert--error">
            <ul>
              <li> {{'bss.register.error.password.required' | translate }}</li>
            </ul>
          </div>

          <div id="passwordError" role="alert" aria-live="assertive"
            *ngIf="(registerForm.get('password').touched || registerForm.get('password').dirty || submitted) && 
            !(registerForm.get('password').errors?.['required']) && (registerForm.get('password').invalid || registerForm.hasError('passwordContainsFName') || registerForm.hasError('passwordContainsLName') ||registerForm.hasError('passwordContainsEmail')) "
            class="ontario-alert ontario-alert--error">

            <ul>
              <div *ngIf="registerForm.get('password').invalid && registerForm.get('password').hasError('startC')">
                <li>{{'bss.register.error.password.beginCharacter' | translate }} </li>
              </div>

              <div *ngIf="registerForm.get('password').invalid && registerForm.get('password').hasError('strongL')">
                <li>{{'bss.register.error.password.needLowerCase' | translate }}</li>
              </div>

              <div *ngIf="registerForm.get('password').invalid && registerForm.get('password').hasError('strongU')">
                <li>{{'bss.register.error.password.needUpperCase' | translate }}</li>
              </div>

              <div *ngIf="registerForm.get('password').invalid && registerForm.get('password').hasError('strongD')">
                <li>{{'bss.register.error.password.needDigit' | translate }}</li>
              </div>

              <div *ngIf="registerForm.get('password').invalid && registerForm.get('password').hasError('strongS')">
                <li>{{'bss.register.error.password.needSpecialChar' | translate }} </li>
              </div>

              <div *ngIf="registerForm.get('password').invalid && registerForm.get('password').hasError('strongDS')">
                <li>{{'bss.register.error.password.disAllowedSpecialChar' | translate }} </li>
              </div>

              <div *ngIf="registerForm.get('password').invalid && registerForm.get('password').hasError('strongR')">
                <li>{{'bss.register.error.password.repeatedChar' | translate }}</li>
              </div>

              <div
                *ngIf="registerForm.get('password').invalid && (registerForm.get('password').errors?.['minlength'] || registerForm.get('password').errors?.['maxlength'] || registerForm.get('password').hasError('passwordTooShort') )">
                <li>{{'bss.register.error.password.length' | translate }}</li>
              </div>

              <div *ngIf="registerForm.hasError('passwordContainsFName')">
                <li>{{'bss.register.error.password.containFirstName' | translate }} </li>
              </div>

              <div *ngIf="registerForm.hasError('passwordContainsLName')">
                <li>{{'bss.register.error.password.containLastName' | translate }} </li>
              </div>
              <div *ngIf="registerForm.hasError('passwordContainsEmail')">
                <li>
                  {{
                  "bss.passwordReset.error.password.containEmail" | translate
                  }}
                </li>
              </div>

            </ul>
          </div>

        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-columns ontario-small-12 ontario-medium-3">
          <label class="ontario-label" for="confirmPassword">
            {{'bss.register.confirmPassword' | translate }} <span class="ontario-label__flag">
              ({{'bss.register.required' | translate }})</span>
          </label>
        </div>

        <div class="ontario-columns ontario-small-12 ontario-medium-9">
          <div class="toggle-container ontario-input--20-char-width">
            <input aria-describedby="confirmPasswordError" tabindex="111" formControlName="confirmPassword"
              id="confirmPassword" name="confirmPassword"
              type="{{ showConfirmPassword === false ? 'password' : 'text' }}"
              title="{{ 'bss.register.confirmPassword.input.title' | translate }}"
              class="ontario-input ontario-input--20-char-width">

            <a tabindex="112" id="confirmPasswordToggler" *ngIf="registerForm.get('password').value"
              (click)="toggleShowConfirmPassword()" (keyup.enter)="toggleShowConfirmPassword()"
              title="{{ showConfirmPassword === false ? ('bss.register.showConfirmPassword.title' | translate) : ('bss.register.hideConfirmPassword.title' | translate) }}">
              {{ showConfirmPassword === false ? ('bss.register.confirmPassword.show' | translate) :
              ('bss.register.confirmPassword.hide' | translate) }}
            </a>
          </div>

          <div id="confirmPasswordError" role="alert" aria-live="assertive"
            *ngIf="submitted && (registerForm.get('confirmPassword').errors?.['required'])"
            class="ontario-alert ontario-alert--error">
            <ul>
              <li>{{'bss.register.error.confirmPassword.required' | translate }} </li>
            </ul>
          </div>

          <div id="confirmPasswordError" role="alert" aria-live="assertive"
            *ngIf="(registerForm.get('confirmPassword').touched || registerForm.get('confirmPassword').dirty) && ((registerForm.get('confirmPassword').errors?.['required']) || registerForm.hasError('mismatch') )"
            class="ontario-alert ontario-alert--error">

            <ul>
              <div *ngIf="(registerForm.get('confirmPassword').errors?.['required'])">
                <li>{{'bss.register.error.confirmPassword.required' | translate }} </li>
              </div>
              <div
                *ngIf="!registerForm.get('confirmPassword').errors?.['required'] && registerForm.hasError('mismatch')">
                <li>{{'bss.register.error.confirmPassword.mismatch' | translate }} </li>
              </div>
            </ul>
          </div>

        </div>
      </dd></dl>
    </div>

    <div class="ontario-row">
      <dl><dt></dt><dd>
        <div class="ontario-column ontario-small-12">
          <fieldset class="ontario-fieldset">
            <div class="ontario-checkboxes">
              <div class="ontario-checkboxes__item">
                <input aria-describedby="agreeReqError" tabindex="114" class="ontario-checkboxes__input" id="agreeTerms"
                  name="agreeTerms" type="checkbox" value="agreeTerms"
                  title="{{'bss.register.agreeTerms.title' | translate }}" formControlName="agreeTerms"
                  (click)="checkCheckbox($event)" #checkbox>
                <label class="ontario-checkboxes__label" for="agreeTerms">
                  {{'bss.register.agreeTerms.part1' | translate }}
                </label>
                <button #termsButton tabindex="113" class="terms-of-service" title="{{'bss.register.agreeTerms.part2.title' |
                translate }}" (click)="handleButtonClick2()">{{'bss.register.agreeTerms.part2' |
                  translate }}
                </button>

                <dialog class="ontario-popup modal" #myDialog>
                  <div class="modal-dialog ">
                    <div class="ontario-row">
                    
                      <div class="ontario-popup-closerow" (click)="onDialogClose()">
                        
                        <img tabindex="151" src='assets/logos/ontario-logo--popup.png' #preventOutsideTab
                          class="ontario-popup--logo" alt="{{'bss.register.popupWindow.ontarioGovLogo' | translate }}"
                          title="{{'bss.register.popupWindow.ontarioGovLogo' | translate }}" role='img' (keydown)="handleShiftTab($event)"/>
                        <button tabindex="156" aria-label="Close" class="ontario-popup-closerow-button not-print" #xCloseButton
                          title="{{'bss.register.button.closePopup'|translate}}" (click)="myDialog.close()"
                          (keyup.enter)="myDialog.close()">
                          &times;
                        </button>
                      </div>

                    </div>
                    <div class="ontario-row">
                      <h2 class="ontario-popup-closerow-title">{{'bss.register.popupWindow.title' | translate}}</h2>
                    </div>
                    <div class="ontario-row">
                      <h3>{{'bss.register.popupWindow.termsAndConditions' | translate}}</h3>
                    </div>
                    <div class="ontario-row"
                      [innerHTML]="'bss.register.popupWindow.termsAndConditionsDesc' | translate">
                    </div>
                    <div class="ontario-row">
                      <h3>{{'bss.register.popupWindow.noc' | translate}}</h3>
                    </div>
                    <div class="ontario-row" [innerHTML]="'bss.register.popupWindow.nocDesc' | translate"></div>
                    <div class="ontario-row not-print">
                      <div class="ontario-column ontario-small-12">
                        <button class="ontario-button ontario-button--secondary" tabindex="155"
                          title="{{ 'bss.register.button.closePopup'|translate }}"
                          (click)="onDialogClose();myDialog.close()">
                          {{ 'bss.register.popupWindow.button.close' | translate }}
                        </button>
                        <button class="ontario-button ontario-button--primary" tabindex="154"
                          title="{{ 'bss.register.popupWindow.button.print.title' | translate }}" (click)="onPrint()">
                          {{ 'bss.register.popupWindow.button.print' | translate }}
                        </button>
                      </div>
                      <span tabindex="160" (focus)="focusFirstElement()"></span>
                    </div>
                    
                  </div>

                </dialog>

              </div>
              <div id="agreeReqError" role="alert" aria-live="assertive"
                *ngIf="submitted && (!registerForm.get('agreeTerms').value || (registerForm.get('agreeTerms').errors?.['required']))"
                class="ontario-alert ontario-alert--error">
                <ul>
                  <li>{{'bss.register.error.agreeTerms.required' | translate }} </li>
                </ul>
              </div>
            </div>
          </fieldset>
        </div>
      </dd></dl>
    </div>
  </div>

  <div class="ontario-row">
    <dl><dt></dt><dd>
      <div class="ontario-column ontario-small-12">
        <button tabindex="115" type="submit" (keyup.enter)="onSubmit()" (click)="onSubmit()"
          aria-describedby="pageLevelMessageId" title="{{'bss.register.button.title' | translate }}"
          class="{{ (registerForm.valid && registerForm.value.agreeTerms) ? 'ontario-button ontario-button--primary' : 'ontario-button ontario-button--secondary' }}"
          [ngStyle]="{ 'cursor': (registerForm.invalid || !registerForm.value.agreeTerms || isSubmitting) ? 'not-allowed' : 'pointer' }"
          [disabled]="registerForm.invalid || !registerForm.value.agreeTerms || isSubmitting">
          {{'bss.register.button.register' | translate }}
        </button>

        <p>{{'bss.register.alreadyRegistered' | translate }} <a tabindex="116" (click)="onSignIn()"
            (keyup.enter)="onSignIn()"
            title="{{'bss.register.alreadyRegistered.title' | translate }}">{{'bss.register.alreadyRegistered.Signin' |
            translate }}</a></p>
      </div>
    </dd></dl>
  </div>
</form>
<dialog class="ontario-progress" #progressDialog>

  <app-progress></app-progress>

</dialog>